import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Button } from './ui/button';
import { questionApi } from '../api/question.api';

interface GuidelinesStepProps {
  handleNext: () => void;
}

const GuidelinesStep = ({ handleNext }: GuidelinesStepProps) => {
  const navigate = useNavigate();

  const { data: cooldown } = useQuery({
    queryKey: ['cooldownStatus'],
    queryFn: () => questionApi.checkCooldown(),
    retry: 0,
  });

  const isOnCooldown = cooldown?.onCooldown ?? false;
  const isLimitReached = cooldown?.limitReached ?? false;
  const blockMessage = cooldown?.message ?? cooldown?.limitMessage ?? null;
  const isBlocked = isOnCooldown || isLimitReached;

  return (
    <div className="flex flex-col h-full">
      {/* 유의사항 안내 */}
      <div className="flex-1">
        <h2 className="text-xl font-bold mb-4">설문 작성 전 확인해주세요</h2>
        <ul className="space-y-3 text-sm text-muted-foreground">
          <li className="flex items-start gap-2">
            <span className="text-primary mt-0.5">•</span>
            <span>설문 유효기간은 최대 14일이에요</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-primary mt-0.5">•</span>
            <span>설문 생성 후 4시간 동안 새 설문을 만들 수 없어요</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-primary mt-0.5">•</span>
            <span>참여자가 5명을 넘으면 설문을 수정하거나 삭제할 수 없어요</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-primary mt-0.5">•</span>
            <span>부적절한 설문은 신고에 의해 비공개 처리될 수 있어요</span>
          </li>
        </ul>

        {isBlocked && (
          <div className="mt-6 p-3 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-sm text-red-600 font-medium">{blockMessage}</p>
          </div>
        )}
      </div>

      <div className="min-h-[40vh]" />

      {/* 버튼 */}
      <div className="flex gap-3">
        <Button variant="outline" className="flex-1" onClick={() => navigate('/')}>
          취소
        </Button>
        <Button className="flex-1" onClick={handleNext} disabled={isBlocked}>
          확인하고 작성하기
        </Button>
      </div>
    </div>
  );
};

export default GuidelinesStep;
